import { Typography } from '@mui/material';
import NewSmbRenterInviteForm from './NewSmbRenterInviteForm';
import RenterInviteForm from './RenterInviteForm';
import { useRenterInviteController } from './useRenterInvite.controller';

export type RenterInviteFormContentProps = {
  onSuccess?: () => void;
};

const RenterInviteFormContent = ({ onSuccess }: RenterInviteFormContentProps) => {
  const { user, errorMsg, isSmbRenterInvites, useNewForm, customCoverageDisabled, onSubmit } =
    useRenterInviteController({ onSuccess });

  return (
    <>
      <Typography variant="h4" component="h1" mb={1}>
        Invite your renters to apply
      </Typography>
      <Typography mb={4}>
        Please fill out your renter's information below, and we will send them an invitation to
        apply using the email address provided. Providing complete information will help to ensure
        an efficient quoting process for your renter.
      </Typography>
      {isSmbRenterInvites ? (
        <NewSmbRenterInviteForm
          user={user}
          onSubmit={onSubmit}
          errorMsg={errorMsg}
          newCoveragesEnabled={useNewForm}
        />
      ) : (
        <RenterInviteForm
          onSubmit={onSubmit}
          errorMsg={errorMsg}
          customCoverageDisabled={customCoverageDisabled}
        />
      )}
    </>
  );
};

export default RenterInviteFormContent;
